import React, { Component } from 'react'
import { type RetailerRouteComponentProps } from 'legacy/components/RetailerRoute'
import { fetchDepartments, updateDepartment } from 'legacy/common/api'
import { type ScopedRouteParams } from 'legacy/common/types'
import withRetailerRouter from 'legacy/common/withRouter'
import DepartmentsView from 'legacy/routes/catalog/departments/DepartmentsView'
import { type Department } from 'legacy/routes/catalog/types'
import useAccessControl from 'legacy/components/AccessControl/useAccessControl'
import { Flipper } from 'legacy/contexts/flipper/FlipperContext'

interface DepartmentsRouteParams extends ScopedRouteParams {}

interface Props extends RetailerRouteComponentProps<DepartmentsRouteParams> {
  onMount?(c: DepartmentsRoute): void
  hideDefaultDepartments: boolean
}

interface State {
  departments?: Department[]
}

class DepartmentsRoute extends Component<Props, State> {
  state: State = { departments: undefined }

  componentDidMount() {
    const { onMount } = this.props

    this.reloadDepartments()

    if (onMount) {
      onMount(this)
    }
  }

  async reloadDepartments() {
    const {
      match: { params },
    } = this.props

    let departments = (await (fetchDepartments(params) as Promise<{ data: Department[] }>)).data

    if (this.props.hideDefaultDepartments) {
      // the editable field indicates whether it is a custom department
      // hide default means show custom only
      departments = departments.filter(d => d.editable)
    }

    this.setState({
      departments,
    })
  }

  onDepartmentDeleted = async (departmentId: number) => {
    const { departments } = this.state
    if (departments) {
      this.setState({
        departments: departments.filter(department => department.id !== departmentId),
      })
    }
  }

  onDepartmentsOrderChange = async (departmentId: number, rankOffsetPosition: number) => {
    const {
      match: { params },
    } = this.props
    const { departments } = this.state

    if (!departments) {
      return
    }

    const newDepartments = departments.filter(department => department.id !== departmentId)
    newDepartments.splice(
      rankOffsetPosition,
      0,
      departments.find(department => department.id === departmentId) as Department
    )
    this.setState({ departments: newDepartments })

    await updateDepartment(params, departmentId, { rank_offset_position: rankOffsetPosition })
  }

  render() {
    const { departments } = this.state

    return (
      <DepartmentsView
        departments={departments}
        onDepartmentDeleted={this.onDepartmentDeleted}
        onDepartmentsOrderChange={this.onDepartmentsOrderChange}
        onReload={() => this.reloadDepartments()}
      />
    )
  }
}

const withFlipper = (Component: any) => {
  return (props: RetailerRouteComponentProps<DepartmentsRouteParams>) => {
    const hasAccess = useAccessControl()
    const hideDefaultDepartments = hasAccess({
      warehouseFlippers: Flipper.HideDefaultDepartments,
    })

    return <Component hideDefaultDepartments={hideDefaultDepartments} {...props} />
  }
}

export default withRetailerRouter(withFlipper(DepartmentsRoute))
